// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2JFR7","header":"ClearentDisclaimer_header__3QgT2","inner":"ClearentDisclaimer_inner__2kH32"};